// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"37d5a819","578":"35d6d6aa"}[chunkId] + ".chunk.js";
};